// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1DnR9","file":"styles_file__2QyI4"};